/**
 * AppLovin Axon Pixel event helpers. The base pixel is loaded in
 * public/index.html (pixel ID 556ebec0-e491-4c7b-9685-d84ce8d94983), which
 * fires the initial page_view; everything else goes through these wrappers
 * so a blocked or missing axon never breaks the app.
 *
 * Standard events: page_view, generate_lead (currency + value required),
 * sign_up, subscribe, login, search, view_item, add_to_cart, begin_checkout,
 * purchase. There is no complete_registration in Axon's vocabulary.
 */

// Nominal value AppLovin requires on generate_lead; tune if lead values are known.
const LEAD_VALUE = 1;
const LEAD_CURRENCY = 'USD';

export const trackAppLovinEvent = (eventName: string, eventData?: { [key: string]: any }) => {
    const { axon } = window as any;
    if (typeof axon !== 'function') {
        return;
    }
    if (eventData) {
        axon('track', eventName, eventData);
    } else {
        axon('track', eventName);
    }
};

export const trackAppLovinPageView = () => {
    trackAppLovinEvent('page_view');
};

export const trackAppLovinLead = () => {
    trackAppLovinEvent('generate_lead', { currency: LEAD_CURRENCY, value: LEAD_VALUE });
};
